<template>
  <v-card>
    <v-card-text>
      <v-container>
        <v-data-table
          class="border-table"
          density="compact"
          :headers="headers"
          hide-no-data
          item-value="id"
          :items="backups">
          <template #header.actions>
            <v-text-field
              hide-details
              placeholder="Backup Name"
              :rules="[(v) => !!v]"
              data-cy="backup-name-input"
              density="compact"
              append-icon="mdi-plus"
              variant="underlined"
              @click:append="createBackup"
              v-model="backupName">
            </v-text-field
          ></template>
          <template #item.date="{ value }">
            {{ new Date(value).toLocaleString() }}
          </template>
          <template #item.actions="{ item }">
            <v-icon
              color="grey"
              size="large"
              :data-cy="item.name + '-embedded-import'"
              @click="importBackup(item.id)">
              mdi-database-import-outline
            </v-icon>
            <v-icon
              v-if="!item.id.includes('__Automatic_Backup.json')"
              color="grey"
              size="large"
              :data-cy="item.name + '-embedded-delete'"
              @click="deleteWithConfirmation(item.id)">
              mdi-delete-outline
            </v-icon>
          </template>
        </v-data-table>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn
        data-cy="close-space-edit"
        @click="emitClose"
        >Schließen</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script lang="ts" setup>
import { useSpaceStore } from "@/stores/spaceStore";
import axios from "axios";
import { useTranslation } from "i18next-vue";
import { onMounted } from "vue";
import { computed } from "vue";
import { ref } from "vue";
import { useConfirm, useSnackbar } from "vuetify-use-dialog";

import { useMainStore } from "@/stores/mainStore";

const mainStore = useMainStore();

const { t } = useTranslation();
const createConfirm = useConfirm();
const createSnackbar = useSnackbar();

const backupName = ref("");

const backups = ref([]);

const spaceStore = useSpaceStore();

const headers: any = computed(() => [
  {
    title: "Name",
    align: "start",
    sortable: false,
    key: "name",
    width: "25%"
  },
  {
    title: "Datum",
    key: "date",
    sortable: false,
    width: "25%"
  },
  {
    title: "",
    key: "actions",
    sortable: false,
    align: "end",
    width: "50%"
  }
]);

const emit = defineEmits(["close"]);

function emitClose() {
  emit("close");
}

onMounted(() => {
  listBackups();
});

function listBackups() {
  axios
    .get(`/api/backup/${mainStore.activeSpaceId}/list-backups`)
    .then((result) => {
      backups.value = result.data;
    })
    .catch((error) => console.error);
}

const manualBackupsCount = computed(() => {
  return backups.value.filter(
    (backup) => !backup.id.includes("__Automatic_Backup.json")
  ).length;
});

function createBackup() {
  if (backupName.value) {
    if (manualBackupsCount.value < 5) {
      axios
        .post(`/api/backup/${mainStore.activeSpaceId}/create-backup`, {
          name: backupName.value
        })
        .then((result) => {
          backupName.value = "";
          listBackups();
        })
        .catch((error) => console.error);
    } else {
      createSnackbar({
        text: t("actions.max_backups_reached"),
        showCloseButton: false,
        snackbarProps: { color: "error", timeout: 3000 }
      });
    }
  }
}

function importBackup(id: string) {
  createConfirm({
    dialogProps: { width: 400 },
    cardProps: { color: "success" },
    title: t("actions.confirmation.import-backup.title"),
    content: t("actions.confirmation.import-backup.content"),
    confirmationText: t("actions.confirmation.import-backup.confirm"),
    cancellationText: t("actions.confirmation.import-backup.cancel"),
    cancellationButtonProps: {
      "data-cy": "import-cancel-button"
    },
    confirmationButtonProps: {
      color: "warning",
      "data-cy": "import-confirm-button"
    }
  }).then((confirm) => {
    if (confirm) {
      axios
        .post(`/api/backup/${mainStore.activeSpaceId}/import-backup/${id}`)
        .then((result) => {
          // backups.value = result.data;
          window.location.reload();
        })
        .catch((error) => console.error);
      // createSnackbar({
      //   text: t("actions.deleted"),
      //   showCloseButton: false,
      //   snackbarProps: { color: "error", timeout: 1000 }
      // });
    }
  });
}

function deleteWithConfirmation(id: string) {
  createConfirm({
    dialogProps: { width: 400 },
    cardProps: { color: "error" },
    title: t("actions.confirmation.delete.title"),
    content: t("actions.confirmation.delete.content"),
    confirmationText: t("actions.confirmation.delete.confirm"),
    cancellationText: t("actions.confirmation.delete.cancel"),
    cancellationButtonProps: {
      "data-cy": "delete-cancel-button"
    },
    confirmationButtonProps: {
      color: "warning",
      "data-cy": "delete-confirm-button"
    }
  }).then((confirm) => {
    if (confirm) {
      deleteBackup(id);
      createSnackbar({
        text: t("actions.deleted"),
        showCloseButton: false,
        snackbarProps: { color: "error", timeout: 1000 }
      });
    }
  });
}

function deleteBackup(id: string) {
  // return console.log("deleteBackup");
  axios
    .post(`/api/backup/${mainStore.activeSpaceId}/delete-backup`, {
      filename: id
    })
    .then((result) => {
      listBackups();
    })
    .catch((error) => console.error);
}
</script>
